import { IntlFormatters } from 'react-intl';

import { IStore } from '@rbi-ctg/store';
import { ServiceMode } from 'state/service-mode/types';
import { StoreState } from 'state/store/hooks';

import { getCateringPickupMessage } from './catering-pickup-msg';
import { messages } from './service-mode-messages';

export { default as paddingForServiceModeHeader } from './padding-for-service-mode';

export const getAddressMessage = (
  store: StoreState | IStore,
  serviceMode: string,
  userAddress: string,
  formatMessage: Function,
  isMobile: boolean
) => {
  let addressMessage: string = formatMessage(messages.howWouldYouLikeToReceiveThisOrder);
  if (store.hasSelection) {
    const storeAddress = store?.physicalAddress?.address1 || '';
    switch (serviceMode) {
      case ServiceMode.EAT_IN:
        addressMessage = `${formatMessage(messages.dineInAt)} ${storeAddress}`;
        break;
      case ServiceMode.CATERING_PICKUP:
        addressMessage = isMobile
          ? getCateringPickupMessage(formatMessage, storeAddress)
          : `${formatMessage(messages.cateringPickUpAt)} ${storeAddress}`;
        break;
      case ServiceMode.CURBSIDE:
        addressMessage = `${formatMessage(messages.curbsideAt)} ${storeAddress}`;
        break;
      case ServiceMode.TAKEOUT:
        addressMessage = `${formatMessage(messages.pickUpAt)} ${storeAddress}`;
        break;
      case ServiceMode.DRIVE_THRU:
        addressMessage = `${formatMessage(messages.driveThruAt)} ${storeAddress}`;
        break;
      case ServiceMode.DELIVERY:
        const address = userAddress?.split(',')[0] || '';
        addressMessage = `${formatMessage(messages.deliverTo)} ${address}`;
        break;
      default:
        addressMessage = `${formatMessage(messages.orderingFrom)} ${storeAddress}`;
        break;
    }
  }
  // user has not selected a pickup location yet, but has catering pickup mode
  if (!store.hasSelection && serviceMode === ServiceMode.CATERING_PICKUP) {
    addressMessage = formatMessage(messages.pickUpAtSelectALocation);
  }
  return addressMessage;
};

type CateringServiceMode = ServiceMode.CATERING_DELIVERY | ServiceMode.CATERING_PICKUP;

export const isCatering = (serviceMode: ServiceMode | null): serviceMode is CateringServiceMode =>
  serviceMode === ServiceMode.CATERING_DELIVERY || serviceMode === ServiceMode.CATERING_PICKUP;

export const isCateringDelivery = (
  serviceMode: ServiceMode | null
): serviceMode is CateringServiceMode => serviceMode === ServiceMode.CATERING_DELIVERY;

export const isCateringPickup = (
  serviceMode: ServiceMode | null
): serviceMode is CateringServiceMode => serviceMode === ServiceMode.CATERING_PICKUP;

export const isDelivery = (serviceMode: ServiceMode | null): serviceMode is ServiceMode.DELIVERY =>
  serviceMode === ServiceMode.DELIVERY;

export const getLocalizedServiceMode = (
  serviceMode: ServiceMode,
  formatMessage: IntlFormatters['formatMessage']
): string => {
  switch (serviceMode) {
    case ServiceMode.DRIVE_THRU:
      return formatMessage(messages.driveThru);
    case ServiceMode.EAT_IN:
      return formatMessage(messages.dineIn);
    case ServiceMode.TAKEOUT:
      return formatMessage(messages.takeOut);
    case ServiceMode.CURBSIDE:
      return formatMessage(messages.curbside);
    case ServiceMode.DELIVERY:
      return formatMessage(messages.delivery);
    case ServiceMode.CATERING_DELIVERY:
      return formatMessage(messages.cateringDelivery);
    case ServiceMode.CATERING_PICKUP:
      return formatMessage(messages.cateringPickUp);
    default:
      return '';
  }
};

export const getOrderingDisabledStoreSelectionMessage = (
  store: StoreState | IStore,
  formatMessage: IntlFormatters['formatMessage']
): string => {
  const storeAddress = store?.physicalAddress?.address1 || '';
  return store.hasSelection
    ? formatMessage(messages.yourSelectedRestaurantIs, { storeAddress })
    : formatMessage(messages.selectRestaurantToViewOffers);
};
